/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { MiddlewareSteps, HttpResponseCodes, TransportMiddlewareProps, AuthInternalError } from '../../../../core';

import type { TransportMiddlewareContext, TransportMiddlewareRequest, TransportMiddlewareResponse, NextFunction } from '../../../../core';

const { Unauthorized } = HttpResponseCodes;

export const handleUnauthorizedErrorMiddleware = <T, R, E>(
    next: NextFunction<TransportMiddlewareResponse<R, E> | Error>,
    ctx: TransportMiddlewareContext,
    req: TransportMiddlewareRequest<T>,
    res: TransportMiddlewareResponse<R, E>
) => {
    const { commands } = ctx;
    const { allowedAuthAttempts } = req;
    const { response } = res;
    const { ok, status } = response ?? {};

    if (!ok && status === Unauthorized && allowedAuthAttempts <= 1) {
        res[TransportMiddlewareProps.ErrorResponse] = new AuthInternalError(req.url);
        next();
    } else if (!ok && status === Unauthorized && allowedAuthAttempts > 0) {
        commands.refreshToken()
            .catch(() => {
                res[TransportMiddlewareProps.ErrorResponse] = new AuthInternalError(req.url);
                next();
                return Promise.reject();
            })
            .then(() => {
                req.allowedAuthAttempts -= 1;
                req.rerunConfig.setStep(MiddlewareSteps.Prepare);
                next(res);
            })
            .catch(() => {
                // catch reject from line 30
            });
    } else {
        next();
    }
};
